var yswProductSchema = {};
(function ($) {
	yswProductSchema = {
		liquidSchema: {},
		go: function () {
			setTimeout(function () {
				if ($('.stamped-header meta[itemprop="ratingValue"]').length > 0) {
					var aggregateRating = {
						'@type': 'AggregateRating',
						ratingValue: $('.stamped-header meta[itemprop="ratingValue"]').attr('content'),
						reviewCount: $('.stamped-header meta[itemprop="ratingCount"]').attr('content'),
						bestRating: '5',
						worstRating: '1'
					};
					yswProductSchema.liquidSchema.aggregateRating = aggregateRating;
          
					var reviews = [];
					$('.stamped-reviews .stamped-review').each(function () {
						var review = {
							'@type': 'Review',
							author: (review = $(this)).find('.author').text(),
							description: review.find('.stamped-review-content-body').text(),
							name: review.find('.stamped-review-header-title').text()
						};
						reviews.push(review);
					});
					yswProductSchema.liquidSchema.review = reviews;
				}
				//else {
				//            reviews = [];
				//              reviewDefault={ "@type": "Review", author: "Linda Livingston", description: "It is a beautifulautiful, comfortable and well made piece of furniture.", name: "Beautiful" };
				//              reviews.push(reviewDefault);
				//             yswProductSchema.liquidSchema.review = reviews;

				//           yswProductSchema.liquidSchema.aggregateRating={ "@type": "AggregateRating", ratingValue:5, reviewCount: 1, bestRating: "5", worstRating: "1" };

				//  }
				var el = document.createElement('script');
				el.type = 'application/ld+json';
				el.text = JSON.stringify(yswProductSchema.liquidSchema);
				console.log($('span.stamped-badge-caption').attr('data-reviews'));
				document.querySelector('.schema').appendChild(el);
			}, 1000);
		}
	};
})(jQuery);
